export const stringToColour = (str?: string) => {
  if (!str) {
    return "#2222ff88";
  }
  let hash = 0;
  str.split("").forEach((char) => {
    hash = char.charCodeAt(0) + ((hash << 5) - hash);
  });
  let colour = "#";
  for (let i = 0; i < 3; i++) {
    let value = (hash >> (i * 8)) & 255;
    // Shift color into red spectrum
    if (i === 1) {
      value = Math.floor((3 * value) / 4);
      value = value + 63;
    } else {
      value = Math.floor((2 * value) / 3);
    }
    colour += value.toString(16).padStart(2, "0");
  }
  return colour;
};
